export const SUPPORTED_LOCALE_CODES = [
    'ar-SA',
    'ar',
    'bg-BG',
    'bg',
    'ca-ES',
    'ca',
    'cs-CZ',
    'cs',
    'cy-GB',
    'cy',
    'da-DK',
    'da',
    'de-DE',
    'de',
    'en-GB',
    'en',
    'es-CO',
    'es-ES',
    'es',
    'fi-FI',
    'fi',
    'fr-FR',
    'fr',
    'he-IL',
    'he',
    'hr-HR',
    'hr',
    'hu-HU',
    'hu',
    'id-ID',
    'id',
    'it-IT',
    'it',
    'ja',
    'ko-KR',
    'ko',
    'nb-NO',
    'nl-NL',
    'nl',
    'no',
    'pl-PL',
    'pl',
    'pt-BR',
    'pt',
    'ro-RO',
    'ro',
    'ru-RU',
    'ru',
    'sl-SI',
    'sl',
    'sr-RS',
    'sr',
    'sv-SE',
    'sv',
    'tr-TR',
    'tr',
    'uk-UA',
    'uk',
    'zh-CN',
    'zh-TW',
];
export const LANGUAGE_PICKER_OPTIONS = [
    { code: 'ar', label: 'العربية' },
    { code: 'bg', label: 'български' },
    { code: 'ca', label: 'català' },
    { code: 'cs', label: 'čeština' },
    { code: 'cy', label: 'Cymraeg' },
    { code: 'da', label: 'dansk' },
    { code: 'de', label: 'Deutsch' },
    { code: 'en-GB', label: 'English', region: 'United Kingdom' },
    { code: 'en', label: 'English', region: 'United States' },
    { code: 'es-CO', label: 'español', region: 'Colombia' },
    { code: 'es', label: 'español', region: 'España' },
    { code: 'fi', label: 'suomi' },
    { code: 'fr', label: 'français' },
    { code: 'he', label: 'עברית' },
    { code: 'hr', label: 'hrvatski' },
    { code: 'hu', label: 'magyar' },
    { code: 'id', label: 'Bahasa Indonesia' },
    { code: 'it', label: 'italiano' },
    { code: 'ja', label: '日本語' },
    { code: 'ko', label: '한국어' },
    { code: 'nb-NO', label: 'norsk bokmål', region: 'Norge' },
    { code: 'nl', label: 'Nederlands' },
    { code: 'no', label: 'norsk' },
    { code: 'pl', label: 'polski' },
    { code: 'pt', label: 'português' },
    { code: 'ro', label: 'română' },
    { code: 'ru', label: 'русский' },
    { code: 'sl', label: 'slovenščina' },
    { code: 'sr', label: 'српски' },
    { code: 'sv', label: 'svenska' },
    { code: 'tr', label: 'Türkçe' },
    { code: 'uk', label: 'українська' },
    { code: 'zh-CN', label: '简体中文', region: '中国' },
    { code: 'zh-TW', label: '繁體中文', region: '台灣' },
];
